import { gsap } from 'gsap'

class ToggleElement {
  constructor(element) {
    this.element = element
    this.target = element.getAttribute('data-target')
    this.classes = element.getAttribute('data-classes')
    this.siblingsClass = element.getAttribute('data-siblings')
    this.siblings = [...document.querySelectorAll(this.siblingsClass)]
    this.delayedClasses = element.getAttribute('data-delayed-classes')
    this.closingOutsideClick = element.hasAttribute('data-closing-outside-click')
    this.isExpanded = false

    this.targetDomEl = document.querySelector(this.target) ?? element

    if (!this.element.hasAttribute('aria-expanded')) {
      this.element.setAttribute('aria-expanded', 'false')
    }

    if (this.siblings.length === 0) {
      this.siblings = [this.element]
    }

    // Mobile nav stagger — only for the hamburger/nav-toggler
    this.isMobileNavToggler = this.siblingsClass === '[data-nav-toggler]'
    if (this.isMobileNavToggler) {
      this.mobileNavItems = [...document.querySelectorAll('.nav--main-nav .nav__item--parent')]
      this.mobileNavMeta = document.querySelector('.header__nav-meta')
    }

    this.element.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      this.toggle()

    }, false)

    if (this.closingOutsideClick && this.targetDomEl) {
      document.body.addEventListener('click', (event) => {
        if (!this.isExpanded) { return }
        if (this.targetDomEl.contains(event.target)) { return }

        this.toggle()

      }, false)
    }

  }

  toggle() {
    const oldStatus = (this.element.getAttribute('aria-expanded') === 'true')
    this.isExpanded = !oldStatus

    this.siblings.forEach(item => {
      if (item === this.targetDomEl || this.isExpanded) {
        item.setAttribute('aria-expanded', 'true')
      } else {
        item.setAttribute('aria-expanded', 'false')
      }
    })

    //for animation and visible in css
    if (this.delayedClasses) {
      if (!this.isExpanded) {
        setTimeout(() => {
          this.targetDomEl.classList.remove(this.delayedClasses)
        }, 300);
      } else {
        this.targetDomEl.classList.add(this.delayedClasses)
      }
    }
    if (this.classes) {
      if (this.isMobileNavToggler && !this.isExpanded) {
        setTimeout(() => {
          this.targetDomEl.classList.remove(this.classes)
        }, 300)
      } else if (this.isMobileNavToggler) {
        this.targetDomEl.classList.add(this.classes)
      } else {
        this.targetDomEl.classList.toggle(this.classes)
      }
    }

    this._animateMobileNav()
  }

  _animateMobileNav() {
    if (!this.isMobileNavToggler || !this.mobileNavItems?.length) return

    const items = this.mobileNavItems
    const meta = this.mobileNavMeta
    const animatedElements = meta ? [...items, meta] : items

    gsap.killTweensOf(animatedElements)

    if (this.isExpanded) {
      // Panel slides in — stagger items in after it arrives
      gsap.fromTo(items,
        { autoAlpha: 0, x: 20 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 0.45,
          ease: 'sine.out',
          delay: 0.25,
          stagger: { each: 0.07, from: 'start' },
          clearProps: 'opacity,visibility,transform',
        }
      )

      if (meta) {
        gsap.fromTo(meta,
          { autoAlpha: 0, x: 20 },
          {
            autoAlpha: 1,
            x: 0,
            duration: 0.45,
            ease: 'sine.out',
            delay: 0.25 + (items.length * 0.07),
            clearProps: 'opacity,visibility,transform',
          }
        )
      }
    } else {
      // Short pause after class removal, then stagger out before panel slides away
      gsap.to(animatedElements, {
        autoAlpha: 0,
        x: 20,
        duration: 0.1,
        ease: 'sine.in'
      })
    }
  }

}

export default ToggleElement